/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AppointmentEpisode from './appointment-episode';
import AppointmentEpisodeDetail from './appointment-episode-detail';
import AppointmentEpisodeUpdate from './appointment-episode-update';
import AppointmentEpisodeDeleteDialog from './appointment-episode-delete-dialog';

const AppointmentEpisodeRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AppointmentEpisode />} />
    <Route path="new" element={<AppointmentEpisodeUpdate />} />
    <Route path=":id">
      <Route index element={<AppointmentEpisodeDetail />} />
      <Route path="edit" element={<AppointmentEpisodeUpdate />} />
      <Route path="delete" element={<AppointmentEpisodeDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AppointmentEpisodeRoutes;
